<template>
    <access-denied v-if="!permissao.read" title="portal-do-cliente" />
    <div style="height: 100%" v-else>
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('portal-do-cliente') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t($route.meta.contexto) }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('portal-do-cliente') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="showManageAcesso = true"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- ABAS -->
                    <!-- <ul class="nav nav-tabs">
                        <li
                            v-for="(aba, i) in abas"
                            :class="{ active: abaSelecionada == i }"
                            :key="i"
                            @click="changeTab(i)"
                        >
                            <a data-toggle="tab">{{ $t(aba) }}</a>
                        </li>
                    </ul> -->

                    <ManageAcessoCliente
                        :showFilter="showManageAcesso"
                        :empresaList="empresaList"
                        :clienteList="clienteList"
                        :idToEdit="idToEdit"
                        @atualizar="carregarDados()"
                        @close="
                            showManageAcesso = false;
                            idToEdit = null;
                        "
                    />

                    <template v-if="abas[abaSelecionada] === 'geral'">
                        <div>Em construção...</div>
                    </template>
                    <template v-if="abas[abaSelecionada] === 'acessos'">
                        <!-- PESQUISA E FILTROS -->
                        <div class="columns is-multiline">
                            <div class="column is-4">
                                <search-bar
                                    :onSearch="debouncedOnSearch"
                                    :tooltipLabel="
                                        $t('msg-campo-busca-n', {
                                            n: `${$t('codigo')}, ${$t('nome')} ou ${$t('email')}`,
                                        })
                                    "
                                />
                            </div>

                            <!-- EMPRESAS -->
                            <div class="column is-3">
                                <vss-select
                                    title="empresa"
                                    ref="empresaSelect"
                                    :value="empresaSelected"
                                    :options="empresaList"
                                    :loading="empresaLoading"
                                    @search="carregarEmpresas"
                                    @input="updateEmpresa"
                                    :height="40"
                                    label="nome"
                                    clearable
                                    searchable
                                    multiple
                                    :closeOnSelect="false"
                                />
                            </div>

                            <!-- CLIENTES -->
                            <div class="column is-3">
                                <vss-select
                                    title="cliente"
                                    ref="clienteSelect"
                                    :value="clienteSelected"
                                    :options="clienteList"
                                    :loading="clienteLoading"
                                    @search="carregarClientes"
                                    @input="updateCliente"
                                    :height="40"
                                    label="nome"
                                    clearable
                                    searchable
                                    multiple
                                    :closeOnSelect="false"
                                />
                            </div>
                            <!-- SITUACAO -->
                            <div class="column is-2">
                                <vss-select
                                    title="situacao"
                                    ref="situacaoInput"
                                    :options="situacaoList"
                                    :height="40"
                                    :value="situacaoSelected"
                                    @input="updateSituacao"
                                    mlLabels
                                />
                            </div>
                        </div>

                        <div class="registry-wrapper">
                            <empty-table-message v-if="isEmpty" />
                            <b-table
                                v-else
                                :data="acessoClienteList"
                                class="data-table"
                                @sort="sortTable"
                                backend-sorting
                            >
                                <b-table-column
                                    v-for="(f, i) in fields"
                                    :key="i"
                                    :field="f.key"
                                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                                    :width="f.width"
                                    :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                    :sortable="f.sortable"
                                    :custom-sort="f.sortFn"
                                    v-slot="props"
                                >
                                    <div v-if="f.key == 'excluir'">
                                        <b-button
                                            v-if="permissao.update"
                                            class="action-button"
                                            :type="
                                                props.row['situacao'] == 1
                                                    ? 'is-danger'
                                                    : 'is-success'
                                            "
                                            :icon-right="
                                                props.row['situacao'] == 1 ? 'delete' : 'check'
                                            "
                                            @click="confirmExclusion(props.row)"
                                            v-tippy
                                            :title="
                                                $t(
                                                    props.row['situacao'] == 1
                                                        ? 'desativar'
                                                        : 'reativar'
                                                )
                                            "
                                        />
                                    </div>
                                    <div v-else-if="f.key == 'nome-email-acesso-cliente'">
                                        <a @click="showEdit(props.row)" v-if="permissao.update">
                                            {{ props.row.nome }} <br />
                                            {{ props.row.email }}
                                        </a>
                                        <span v-else
                                            >{{ props.row.nome }} <br />
                                            {{ props.row.email }}</span
                                        >
                                    </div>
                                    <div v-else-if="f.key == 'cliente-cnpjcpf'">
                                        {{ props.row.clienteCnpjcpf }}
                                    </div>
                                    <div v-else-if="f.key == 'situacao'">
                                        <b-tag
                                            class="table-tag table-tag-full-width"
                                            v-if="props.row[f.key] == 1"
                                            type="is-success"
                                            size="is-medium"
                                            >{{ $t('ativo') }}</b-tag
                                        >
                                        <b-tag
                                            class="table-tag table-tag-full-width"
                                            v-else
                                            type="is-danger"
                                            size="is-medium"
                                            >{{ $t('inativo') }}</b-tag
                                        >
                                    </div>
                                    <div v-else-if="f.key == 'codigo'">
                                        {{ props.row.idacs_cliente_cliente }}
                                    </div>
                                    <div v-else>
                                        {{ props.row[f.key] }}
                                    </div>
                                </b-table-column>
                            </b-table>
                            <PaginationViewer
                                class="mb-0"
                                :resetPagination="pagination.resetPagination"
                                :totalItems="pagination.totalRows"
                                :perPageOptions="pagination.perPageOptions"
                                :optionStarted="pagination.optionStarted"
                                @change="updatePagination"
                            />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import ManageAcessoCliente from '@/components/promotor/portal-do-cliente/PortalDoClienteUserManage.vue';

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes(`${this.abrev}-portal-do-cliente`) &&
            to.name != `${this.abrev}-portal-do-cliente-list`
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }
        next();
    },
    components: {
        ContainerLoader,
        ManageAcessoCliente,
    },
    data() {
        return {
            rotaAninhada: false,
            abas: ['geral', 'acessos'],
            abaSelecionada: 1,
            abasAbertas: {},
            acessoClienteList: [],
            situacaoList: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacaoSelected: { id: 2, label: 'todos' },
            fields: [
                { key: 'codigo', sortable: true },
                { key: 'nome-email-acesso-cliente', sortable: true },
                { key: 'cliente', sortable: true },
                { key: 'cliente-cnpjcpf', sortable: true },
                { key: 'empresa', sortable: true },
                { key: 'situacao', sortable: true },
                { key: 'excluir', sortable: false },
            ],
            isLoading: false,
            isEmpty: false,
            searchQuery: '.*',
            rowToUpdateSituacao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            empresaList: [],
            empresaSelected: [],
            empresaLoading: true,
            clienteList: [],
            clienteSelected: [],
            clienteLoading: true,
            modulo: 'p',
            permissao: null,
            showManageAcesso: false,
            showEditAcessoCliente: false,
            idToEdit: null,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.permissao = this.hasPermissionAccess(
            'promotor',
            'portal-do-cliente',
            'portal-do-cliente'
        );

        this.carregarEmpresas();
        this.carregarClientes();
        this.carregarDados();
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            let limit = this.pagination.perPage ? this.pagination.perPage : 10;
            let filtros = {
                search: this.searchQuery,
                order: this.order,
                sort: this.column,
                situacao: this.situacaoSelected.id,
                empresa:
                    this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((e) => e.id),
                cliente:
                    this.clienteSelected.length == 0 ? [] : this.clienteSelected.map((e) => e.id),
                modulo: this.modulo,
            };

            this.$axios
                .post(`/acessoCliente/findAll.json?page=${currentPage - 1}&limit=${limit}`, filtros)
                .then((response) => {
                    this.pagination.totalRows = response.data.totalElements;
                    this.acessoClienteList = response.data.content.map((c) => {
                        return {
                            idacs_cliente_cliente: c.idacs_cliente_cliente,
                            nome: c.nome,
                            email: c.email,
                            cliente: c.clienteNome,
                            clienteCnpjcpf: c.clienteCnpjcpf,
                            empresa: c.empresaNome,
                            situacao: c.situacao,
                        };
                    });
                    this.isEmpty = response.data.totalElements == 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    console.log('[Acessos Cliente] Erro ao carregar acessos de clientes.', e);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.searchQuery = this.removeAcentos(value);
            this.carregarDados();
        },
        confirmExclusion(item) {
            this.modalOpen = true;
            this.rowToUpdateSituacao = item;
            this.$root.confirm({
                message: this.$t(
                    item.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n',
                    { n: item.descricao }
                ),
                onConfirm: (_) => this.updateSituacaoRegistro(),
                onCancel: (_) => {
                    this.rowToUpdateSituacao = null;
                },
            });
        },
        updateSituacaoRegistro() {
            const tempFailure =
                this.rowToUpdateSituacao.situacao == 1
                    ? 'erro-ao-desativar-acesso'
                    : 'erro-ao-reativar-acesso';

            const tempAcessoCliente = {
                idacs_cliente_cliente: this.rowToUpdateSituacao.idacs_cliente_cliente,
                situacao: this.rowToUpdateSituacao.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.$axios
                .post(`/acessoCliente/updatesituacao`, tempAcessoCliente)
                .then((r) => {
                    if (r.data.status == 200) {
                        if (r.data.content.situacao == 1) {
                            this.$root.showMessage('success', 'msg-sucesso-ao-reativar-acesso');
                        } else if (r.data.content.situacao == 0) {
                            this.$root.showMessage('success', 'msg-sucesso-ao-desativar-acesso');
                        }
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.rowToUpdateSituacao = null;
                });
        },
        carregarEmpresas(search = '') {
            this.empresaLoading = true;
            this.$axios
                .get(`/vendas/empresa/list.json?param=${search}`)
                .then((response) => {
                    this.empresaList = Object.assign(response.data.content);
                })
                .catch(() => {
                    this.empresaList = [];
                })
                .finally(() => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.empresaSelected = empresa;
            this.carregarDados();
        },
        carregarClientes(search = '.*') {
            this.clienteLoading = true;
            this.$axios
                .get('/promotor/cliente/getcombo.json', {
                    params: {
                        param: search,
                        situacao: 1,
                    },
                })
                .then((response) => {
                    this.clienteList = Object.assign(response.data.content);
                })
                .catch((e) => {
                    this.clienteList = [];
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        updateCliente(cliente) {
            this.clienteSelected = cliente;
            this.carregarDados();
        },
        updateSituacao(situacao) {
            this.situacaoSelected = situacao;
            this.carregarDados();
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[i]] = true;
            // muda a query
            if (this.$route.query) {
                if (
                    this.$route.query.abaSelecionada &&
                    this.$route.query.abaSelecionada == this.abas[i]
                ) {
                    return;
                }

                let query = { ...this.$route.query };
                query.abaSelecionada = this.abas[i];
                this.$router.replace({ query: query });
            } else {
                this.$router.push({ abaSelecionada: this.abas[i] }).catch((error) => {
                    if (
                        error.name !== 'NavigationDuplicated' &&
                        !error.message.includes('Avoided redundant navigation to current location')
                    )
                        console.log(error);
                });
            }
        },
        showEdit(row) {
            this.idToEdit = row.idacs_cliente_cliente;
            this.showManageAcesso = true;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 15px 15px 21px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
}
</style>
